import React from 'react';
import santahat from './images/santa-hat.svg';

const GenerateButton = (props) => {
    return (
        <button className="generate-button" onClick={props.handleGenerate} type={props.type}>
            <img src={santahat} className="santa-icon" alt="santa-icon" />
            {props.text}
        </button>
    )
}

export default GenerateButton;